<template>
    <div>
        <div class="form-group">
            <h2 data-testid="section-heading" class="mb-4">
                You successfully booked your Information session.
            </h2>
            <p data-testid="paragraph-2">
                We’ve sent you an email confirming your booking. This includes instructions on how to join the session and what you need to do before you attend.
            </p>
            <p>If you can’t find an email from us, make sure to check your junk/spam folder.</p>
        </div>
        <h3 data-testid="add-to-calendar-section">
            Want to add this event to your calendar? Click the link below
        </h3>
        <br>
        <calendar-invite
            :title="title"
            :location="location"
            :url="url"
            :start="start"
            :end="end"
        />
    </div>
</template>

<script setup>
import CalendarInvite from "../CalendarInvite";
import { toDate } from 'date-fns';
import { computed } from "vue";

const props = defineProps({
    sessions: {
        type: Array
    },
    selected: {
        type: Number
    }
})

window.scrollTo(0, 0)

let session = computed(() => {
    return props.sessions.find(session => session.info_session_id === props.selected)
})

let location = computed(() => {
    return session.location
})

let url = computed(() => {
    return session.url
})

let start = computed(() => {
    return toDate(`${session.start_date} ${session.start_time}`, 'yyyy-LL-dd HH:mm', new Date());
})

let end = computed(() => {
    return toDate(`${session.end_date} ${session.end_time}`, 'yyyy-LL-dd HH:mm', new Date());
})
</script>
